<div class="head-count">
  <div class="styled-container">
    <div class="row-container">
      <div class="col">
        <emerald-card>
          <div class="content-container">
            <div class="header-row">
              <div class="heading-title">{{ vendorProfile.contractorHeadCount }}</div>
              <div class="filter">
                <div class="fs-field">
                  <span class="fs-label">Month</span>
                  <select class="native-select has-icon icon-cal" aria-label="Month" (change)="onMonthChange($any($event.target).value)">
                    <option *ngFor="let o of monthOptions" [value]="o.label" [selected]="o.month === selectedMonth && o.year === selectedYear">{{ o.label }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="displayData.length === 0" class="metrics">
            <div class="metric" *ngFor="let metric of metrics">
              <span class="label">{{ metric.label }}</span>
              <span class="value">0</span>
            </div>
          </div>
          <div class="metrics" *ngFor="let data of displayData">
            <div class="metric" *ngFor="let metric of metrics">
              <span class="label">{{ metric.label }}</span>
              <span class="value">{{ data[metric.key] || '0' }}</span>
            </div>
          </div>
        </emerald-card>
      </div>
    </div>
  </div>
</div>
